import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import "./App.css";
import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";

/* ================= TOAST ================= */

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/* ================= PAGES ================= */

import Home from "./Components/home";
import About from "./Components/about";
import Contact from "./Components/contact";

import Login from "./Components/login";
import Register from "./Components/register";
import Welcome from "./Components/welcome";

import DashboardLayout from "./Components/dashboard/DashboardLayout";
import DashboardHome from "./Components/dashboard/dashboard";
import DirectReferrals from "./Components/dashboard/directreferrals";
import SupportIncome from "./Components/dashboard/supportincome";
import AutoPoolIncome from "./Components/dashboard/autopoolincome";
import ReferralIncome from "./Components/dashboard/referralIncome";
import JoiningPayment from "./Components/dashboard/makeinvestment";
import FundTransferList from "./Components/dashboard/fundtransferlist";
import TransferFund from "./Components/dashboard/transferfund";
import Withdraw from "./Components/dashboard/withdraw";
import WithdrawReport from "./Components/dashboard/withdrawreport";
import Invite from "./Components/dashboard/invite";
import EditProfile from "./Components/dashboard/editProfile";
import ChangePassword from "./Components/dashboard/changePassword";
import SelfInvestment from "./Components/dashboard/selfinvestment";
import LevelTwo from "./Components/dashboard/level2";
import LevelThree from "./Components/dashboard/level3";
import MyTeam from "./Components/dashboard/myTeam";

/* ================= PROTECTED ROUTE ================= */

const ProtectedRoute = ({ children }) => {
  const storedUser = sessionStorage.getItem("user");
  const accessToken = sessionStorage.getItem("accessToken");

  if (!storedUser || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

/* ================= APP ================= */

export default function App() {
  return (
    <>
      <Routes>

        {/* ================= PUBLIC PAGES ================= */}

        <Route
          path="/"
          element={<Home />}
        />

        <Route
          path="/about"
          element={<About />}
        />

        <Route
          path="/contact"
          element={<Contact />}
        />

        {/* ================= AUTH PAGES ================= */}

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/register"
          element={<Register />}
        />

        <Route
          path="/referral/:referralCode"
          element={<Register />}
        />

        <Route
          path="/welcome"
          element={<Welcome />}
        />

        {/* ================= PROTECTED DASHBOARD ================= */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >

          <Route
            index
            element={<DashboardHome />}
          />

          <Route
            path="direct-referrals"
            element={<DirectReferrals />}
          />

          <Route
            path="support-income"
            element={<SupportIncome />}
          />

          <Route
            path="edit-profile"
            element={<EditProfile />}
          />

          <Route
            path="change-password"
            element={<ChangePassword />}
          />
          <Route
            path="self-investment"
            element={<SelfInvestment />}
          />

          <Route
            path="level2"
            element={<LevelTwo />}
          />

          <Route
            path="my-team"
            element={<MyTeam />}
          />

          <Route
            path="level3"
            element={<LevelThree />}
          />


          <Route
            path="autopool-income"
            element={<AutoPoolIncome />}
          />

          <Route
            path="referral-income"
            element={<ReferralIncome />}
          />

          <Route
            path="make-investment"
            element={<JoiningPayment />}
          />

          <Route
            path="transfer-list"
            element={<FundTransferList />}
          />

          <Route
            path="transfer-fund"
            element={<TransferFund />}
          />

          <Route
            path="fund-withdrawal"
            element={<Withdraw />}
          />

          <Route
            path="withdrawal-report"
            element={<WithdrawReport />}
          />

          <Route
            path="invite"
            element={<Invite />}
          />

        </Route>

        {/* ================= FALLBACK ================= */}

        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />

      </Routes>

      {/* ================= GLOBAL TOAST ================= */}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </>
  );
}